import { FC, useEffect, useRef, useState } from 'react';
import { FiltersDropdownProps } from './filtersDropdownTypes';
import FiltersWrapper from '../filtersWrapper/filtersWrapper';
import FiltersController from '../filtersController/filtersController';

const FiltersDropdown: FC<FiltersDropdownProps> = (props: FiltersDropdownProps) => {
    const {
        filters,
        onApplyCallback,
        filtersState,
        isPrimary = false,
        customTitle = null,
        filtersControllerCX,
        includeAll = true
    } = props;
    const [filtersToggle, setFiltersToggle] = useState<boolean>(false);
    const filtersRef = useRef() as React.MutableRefObject<HTMLInputElement>;

    useEffect(() => {
        const checkIfClickedOutside = (e: any) => {
            if (filtersToggle && filtersRef.current && !filtersRef.current.contains(e.target)) {
                setFiltersToggle(false);
            }
        };
        document.addEventListener('mousedown', checkIfClickedOutside);
        return () => {
            document.removeEventListener('mousedown', checkIfClickedOutside);
        };
    }, [filtersToggle]);

    const onApply = newFilters => {
        setFiltersToggle(false);
        onApplyCallback(newFilters);
    };

    const wrapperStyle = filtersRef => {
        let wrapperStyle = {
            maxHeight: `${
                window.innerHeight - filtersRef.current.clientHeight - filtersRef.current.getBoundingClientRect().top
            }px`
        };
        if (customTitle) {
            wrapperStyle = {
                ...(wrapperStyle as any),
                right: '0px'
            };
        }
        return wrapperStyle;
    };

    return (
        <div ref={filtersRef}>
            <FiltersController
                onFiltersClick={() => setFiltersToggle(!filtersToggle)}
                filtersCount={Object.keys(filtersState).length}
                clearCallback={() => onApplyCallback({})}
                isPrimary={isPrimary}
                customTitle={customTitle}
                cx={filtersControllerCX}
                includeAll={includeAll}
            />
            {filtersToggle && (
                <FiltersWrapper
                    filters={filters}
                    initialState={filtersState}
                    onApplyCallback={onApply}
                    onCancelCallback={() => {
                        setFiltersToggle(false);
                    }}
                    width={22}
                    filtersWrapperStyle={wrapperStyle(filtersRef)}
                />
            )}
        </div>
    );
};

export default FiltersDropdown;
